import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

// Tomica: Use this file only for temporary things and exceptions,
// everything else should go into shellLocal

export const isRomania = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Ro;
};

export const isPoland = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Pl;
};

export const isSerbia = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Rs;
};

export const isBelgium = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Be;
};

export const isBulgaria = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Bg;
};

export const isBrazil = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.Br || config.countrySpecific.country === Country.Com;
};

export const isRomaniaNapoleon = () => {
    const config = getConfig();
    return config.countrySpecific.country === Country.RoNapoleon;
};
